export default (ms) => {
  let d = new Date(1000*Math.round(ms/1000))
  let pad = (i) => { return ('0'+i).slice(-2) }
  let str = d.getUTCHours() + ':' + pad(d.getUTCMinutes()) + ':' + pad(d.getUTCSeconds())
  return str
}
